import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import makeAsyncScriptLoader from 'react-async-script';
// import chunk from 'lodash.chunk';
// import Slider from 'react-slick';
import Typist from 'react-text-typist';
import ImageWebp from './ImageWebp/ImageWebp';
import Layout from './Layout';
import SEO from './SEO';
import Button from './Button/Button';
import Scrollspy from './ScrollSpy/Scrollspy';

import { expertSpeakers, Faq, videoLnks } from '../utils/contentProvider';
import '../styles/slick.scss';
import '../styles/landing.scss';
import './EarlyAccess/early-access.scss';
import BookingModal from './BookingModal/BookingModal';
import EarlyAccessModal from './EarlyAccessModal/EarlyAccessModal';
import { withEventTracking } from '../utils/tracking';
import Footer from './Footer/Footer';
import useMediaQuery from '../hooks/useMediaQuery';

const Landing = ({ location, offer99, mentorship, ...rest }) => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  let typeSpeed;

  if (isMobile) {
    typeSpeed = '80';
  }
  if (!isMobile) {
    typeSpeed = '150';
  }

  const [tabOpen, setTabOpen] = useState(0);

  const [disablePaid, setDisablePaid] = useState(false);

  const [faq, setFaq] = useState(0);

  const [videoModal, setVideoModal] = useState(false);

  const [openTicketModal, setOpenTicketModal] = useState(false);

  const [pricingMobileOpen, setPricingMobileOpen] = useState(1);

  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [loaddAllExperts, setLoaddAllExperts] = useState(false);

  const tabOpenClick = useCallback(
    (value) => () => setTabOpen((state) => (state === value ? null : value)),
    [],
  );

  const faqClick = useCallback(
    (value) => () => setFaq((state) => (state === value ? null : value)),
    [],
  );

  const videoModalClick = useCallback(
    (value) => () => setVideoModal((state) => (state === value ? null : value)),

    [],
  );

  const pricingMobileOpenClick = useCallback(
    (value) => () =>
      setPricingMobileOpen((state) => (state === value ? null : value)),
    [],
  );

  // const bookingModalOpenToggle = useCallback(() => {
  //   if (location.search.includes('coupon_code')) {
  //     setOpenTicketModal((state) => !state);
  //   } else {
  //     setBookingModalOpen((state) => !state);
  //   }
  // }, [location]);
  const bookingModalOpenToggle = useCallback(() => {
    // do nothing
  }, []);

  const loaddAllExpertsToggle = useCallback(() => {
    setLoaddAllExperts((state) => !state);
  }, []);

  const onEscapeKey = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        if (bookingModalOpen) {
          setBookingModalOpen(false);
        }
        if (videoModal) {
          setVideoModal(false);
        }
      }
    },
    [videoModal, bookingModalOpen],
  );

  const renderSubtext = useCallback(
    () =>
      disablePaid ? null : (
        <p>
          Choose your ticket and book now before slots run out! All proceeds go
          directly to Child Rights and You Foundation.
        </p>
      ),
    [disablePaid],
  );

  const renderPricingBlock = useCallback(
    () => (
      <div className="pricing-block">
        <div className="small-container">
          <div className="row">
            {[
              {
                id: 0,
                category: 'SILVER',
                price: location.search.includes('coupon_code') ? (
                  <>
                    <span>
                      ₹99
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="103"
                        height="2"
                        fill="none"
                        viewBox="0 0 103 2">
                        <path stroke="#F3F3F3" strokeWidth="2" d="M.5 1h102" />
                      </svg>
                    </span>{' '}
                    FREE
                  </>
                ) : (
                  '₹99'
                ),
                mobileText: (
                  <>
                    {/* We save you a seat at FTX 2021. */}
                    {/* <br /> You also help
                        children... */}
                  </>
                ),
                description: (
                  <>
                    <ul>
                      <li>We save you a seat at FTX 2021 😃</li>

                      {/* <li>
                            You also help children without internet access get
                            learning material and worksheets.
                          </li> */}
                    </ul>
                  </>
                ),
                disabled: false,
              },
              {
                id: 1,
                category: 'GOLD',
                price: '₹999',
                mobileText: (
                  <>
                    Get an exclusive goodie bag along with your seat at FTX
                    2021...
                  </>
                ),
                description: (
                  <>
                    <ul>
                      <li>
                        Get an exclusive goodie bag along with your seat at FTX
                        2021 😋
                      </li>

                      <li>
                        You also help children get access to mental health and
                        personal development support.
                      </li>
                    </ul>
                  </>
                ),
                disabled: location.search.includes('coupon_code'),
              },
              {
                id: 2,
                category: 'PLATINUM',
                price: '₹9999',
                mobileText: (
                  <>
                    Stand a chance to meet Razorpay leaders &amp; get an
                    exclusive...
                  </>
                ),
                description: (
                  <>
                    <ul>
                      <li>
                        Stand a chance to meet Razorpay leaders &amp; get an
                        exclusive goodie bag along with your seat at FTX 2021 😃
                      </li>

                      <li>
                        You also help fund bridge schools for children facing
                        learning gaps due to the pandemic.
                      </li>
                    </ul>
                  </>
                ),
                disabled: location.search.includes('coupon_code'),
              },
            ].map(({ id, category, description, price, mobileText }) => (
              <div key={id} className="col-md col-4">
                <div
                  className={`single-pricing ${
                    id === 1
                      ? `gold-price ${disablePaid ? 'disabled' : ''} ${
                          offer99 ? 'disabled' : ''
                        } `
                      : ''
                  } ${
                    id === 2
                      ? `platinum-price ${disablePaid ? 'disabled' : ''} ${
                          offer99 ? 'disabled' : ''
                        } `
                      : ''
                  } ${pricingMobileOpen === id ? 'open-price' : ''}`}
                  role="button"
                  tabIndex="0"
                  onClick={pricingMobileOpenClick(id)}
                  onKeyPress={pricingMobileOpenClick(id)}>
                  <div className="pricing-block-bg">
                    <div className="price-head">
                      <span className="price-category">{category}</span>
                      <h3 className="price">{price}</h3>
                    </div>

                    <p className="visible-mobile">{mobileText}</p>
                    {description}

                    <Button
                      onClick={bookingModalOpenToggle}
                      primary
                      className="hidden-mobile disabled">
                      Book Now
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="center">
            <Button
              onClick={bookingModalOpenToggle}
              primary
              className="visible-mobile disabled">
              Book Now
            </Button>
          </div>
        </div>
      </div>
    ),
    [location, disablePaid],
  );

  useEffect(() => {
    document.body.style.overflow = videoModal ? 'hidden' : 'visible';
    document.body.style.overflow = bookingModalOpen ? 'hidden' : 'visible';
  }, [bookingModalOpen, videoModal]);

  useEffect(() => {
    window.addEventListener('keydown', onEscapeKey);
    return () => {
      window.removeEventListener('keydown', onEscapeKey);
    };
  }, [onEscapeKey]);

  // useEffect(() => {
  //   if (location.search.includes('coupon_code')) {
  //     const couponCode = new URL(window.location.href).searchParams.get(
  //       'coupon_code',
  //     );

  //     setOpenTicketModal(couponCode !== 'FreePassAlt');
  //     setDisablePaid(true);
  //   }
  // }, [location]);

  return (
    <Layout {...rest}>
      <SEO
        title="Razorpay FTX 2021"
        description="A virtual fintech conference for disruptors"
      />

      <Scrollspy>
        <div className="landing-hero">
          {/* <video
            className="landing-bg"
            src="https://ftx-rp.netlify.app/img/landing-hero-video.mp4"
            autoPlay
            loop
            muted
            playsInline
          /> */}

          <div className="container">
            <div className="hero-content">
              {/* <p>It’s time for every business to thrive.</p> */}
              <h1>India’s largest fintech event</h1>
              <h3>9th - 10th December</h3>

              <div className="hero-speakers">
                <div className="flex">
                  <div className="single-hero-speaker hidden-mobile">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/amitabh-kant.webp"
                      src="https://ftx-rp.netlify.app/img/amitabh-kant.jpg"
                      loading="lazy"
                    />
                    <h4>Amitabh Kant </h4>
                    <p>CEO, NITI Aayog</p>
                  </div>
                  <div className="single-hero-speaker">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/lizzie-chapman.webp"
                      src="https://ftx-rp.netlify.app/img/lizzie-chapman.jpg"
                      loading="lazy"
                    />

                    <h4>Lizzie Chapman</h4>
                    <p>CEO, Zestmoney</p>
                  </div>

                  <div className="single-hero-speaker">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/ankur-warikoo.webp"
                      src="https://ftx-rp.netlify.app/img/ankur-warikoo.jpg"
                      loading="lazy"
                    />
                    <h4>Ankur Warikoo</h4>
                    <p>Founder, Nearbuy</p>
                  </div>
                  <div className="single-hero-speaker">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/nitin-kamath.webp"
                      src="https://ftx-rp.netlify.app/img/nitin-kamath.jpg"
                      loading="lazy"
                    />
                    <h4>Nithin Kamath</h4>
                    <p>CEO, Zerodha</p>
                  </div>
                  <div className="single-hero-speaker hidden-mobile">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/rahul-chari.webp"
                      src="https://ftx-rp.netlify.app/img/rahul-chari.jpg"
                      loading="lazy"
                    />
                    <h4>Rahul Chari</h4>
                    <p>CTO, Phonepe</p>
                  </div>
                </div>

                <p>Catch top industry leaders live on one platform</p>
              </div>
              <Button
                className="disabled"
                primary
                onClick={withEventTracking(
                  'HERO_SECTION',
                  bookingModalOpenToggle,
                )}>
                Book my seat
              </Button>
            </div>
          </div>
        </div>

        <div
          className="experts-main"
          data-spy-title="Speakers"
          data-spy-id="speakers">
          <div className="small-container">
            <div className="experts-heading">
              <h3>Unfiltered conversations with</h3>
              <h2 className="big-heading">The experts</h2>
              <p>Get a fresh take on the world of fintech</p>
            </div>
          </div>
          <div className="container">
            <div className="experts-slider">
              <div className="row justify-flex-start align-normal">
                {expertSpeakers
                  .filter((Experts) =>
                    loaddAllExperts ? Experts.id < 200 : Experts.id < 15,
                  )
                  .map(
                    ({
                      id,
                      speakerName,
                      speakerDesignation,
                      Speakerimage,
                      SpeakerimageWebp,
                      linkedinProfile,
                    }) => (
                      <div key={id} className="speaker-col">
                        <div className="speaker-single">
                          <div className="speaker-img">
                            <a
                              href={linkedinProfile}
                              target="_blank"
                              rel="noopener noreferrer">
                              <ImageWebp
                                srcWebp="https://ftx-rp.netlify.app/img/linkedin.webp"
                                src="https://ftx-rp.netlify.app/img/linkedin.png"
                              />
                            </a>

                            <ImageWebp
                              srcWebp={SpeakerimageWebp}
                              src={Speakerimage}
                              alt={speakerName}
                            />
                          </div>
                          <div className="speaker-desc">
                            <h3>{speakerName}</h3>
                            <p>{speakerDesignation}</p>
                          </div>
                        </div>
                      </div>
                    ),
                  )}
              </div>

              <div className="center button-row" style={{ marginTop: 30 }}>
                <Button
                  className={loaddAllExperts ? 'hidden' : ''}
                  primary
                  onClick={loaddAllExpertsToggle}>
                  SEE ALL SPEAKERS
                </Button>

                <Button
                  className="disabled"
                  onClick={bookingModalOpenToggle}
                  primary>
                  REGISTER NOW
                </Button>
              </div>
            </div>

            {/* <Slider
              className="hidden-mobile"
              arrows={false}
              dots={false}
              infinite
              slidesToShow={5}
              slidesToScroll={1}
              autoplay={false}
              speed={400}
              cssEase="linear"
              swipeToSlide
              responsive={[
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 990,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    speed: 400,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: true,
                  },
                },
              ]}>
              {expertSpeakers
                .filter((Experts) => Experts.id > 6 && Experts.id < 14)
                .map(
                  ({
                    id,
                    speakerName,
                    speakerDesignation,
                    Speakerimage,
                    SpeakerimageWebp,
                    linkedinProfile,
                  }) => (
                    <div key={id} className="item">
                      <div className="speaker-single">
                        <div className="speaker-img">
                          <a
                            href={linkedinProfile}
                            target="_blank"
                            rel="noopener noreferrer">
                            <ImageWebp
                              srcWebp="https://ftx-rp.netlify.app/img/linkedin.webp"
                              src="https://ftx-rp.netlify.app/img/linkedin.png"
                            />
                          </a>

                          <ImageWebp
                            srcWebp={SpeakerimageWebp}
                            src={Speakerimage}
                            alt={speakerName}
                          />
                        </div>
                        <div className="speaker-desc">
                          <h3>{speakerName}</h3>
                          <p>{speakerDesignation}</p>
                        </div>
                      </div>
                    </div>
                  ),
                )}
            </Slider>
            <Slider
              className="hidden-mobile"
              arrows={false}
              dots={false}
              infinite
              slidesToShow={5}
              slidesToScroll={1}
              autoplay={false}
              speed={400}
              cssEase="linear"
              swipeToSlide
              responsive={[
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 990,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    speed: 400,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: true,
                  },
                },
              ]}>
              {expertSpeakers
                .filter((Experts) => Experts.id > 12 && Experts.id < 40)
                .map(
                  ({
                    id,
                    speakerName,
                    speakerDesignation,
                    Speakerimage,
                    SpeakerimageWebp,
                    linkedinProfile,
                  }) => (
                    <div key={id} className="item">
                      <div className="speaker-single">
                        <div className="speaker-img">
                          <a
                            href={linkedinProfile}
                            target="_blank"
                            rel="noopener noreferrer">
                            <ImageWebp
                              srcWebp="https://ftx-rp.netlify.app/img/linkedin.webp"
                              src="https://ftx-rp.netlify.app/img/linkedin.png"
                            />
                          </a>

                          <ImageWebp
                            srcWebp={SpeakerimageWebp}
                            src={Speakerimage}
                            alt={speakerName}
                          />
                        </div>
                        <div className="speaker-desc">
                          <h3>{speakerName}</h3>
                          <p>{speakerDesignation}</p>
                        </div>
                      </div>
                    </div>
                  ),
                )}
            </Slider> */}

            {/* <div className="single-expert-slider">
              <div className="container">
                <Slider
                  arrows={false}
                  dots={false}
                  speed={5000}
                  autoplay
                  autoplaySpeed={0}
                  centerMode
                  cssEase="linear"
                  slidesToShow={1}
                  slidesToScroll={1}
                  variableWidth
                  infinite
                  initialSlide={1}
                  responsive={[
                    {
                      breakpoint: 990,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ]}>
                  {Speakers.filter((Speaker) => Speaker.id < 22).map(
                    ({ id, SpeakerName }) => (
                      <div key={id} className="item">
                        <h3 className="single-previous-speaker">
                          {SpeakerName}
                        </h3>
                      </div>
                    ),
                  )}
                </Slider>
              </div>
            </div>
            <div className="single-expert-slider">
              <div className="container">
                <Slider
                  arrows={false}
                  dots={false}
                  speed={5000}
                  autoplay
                  autoplaySpeed={0}
                  centerMode
                  cssEase="linear"
                  slidesToShow={1}
                  slidesToScroll={1}
                  variableWidth
                  infinite
                  initialSlide={1}
                  rtl
                  responsive={[
                    {
                      breakpoint: 990,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ]}>
                  {Speakers.filter(
                    (Speaker) => Speaker.id > 22 && Speaker.id < 44,
                  ).map(({ id, SpeakerName }) => (
                    <div key={id} className="item">
                      <h3 className="single-previous-speaker">{SpeakerName}</h3>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            <div className="single-expert-slider">
              <div className="container">
                <Slider
                  arrows={false}
                  dots={false}
                  speed={5000}
                  autoplay
                  autoplaySpeed={0}
                  centerMode
                  cssEase="linear"
                  slidesToShow={1}
                  slidesToScroll={1}
                  variableWidth
                  infinite
                  initialSlide={1}
                  responsive={[
                    {
                      breakpoint: 990,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ]}>
                  {Speakers.filter((Speaker) => Speaker.id > 44).map(
                    ({ id, SpeakerName }) => (
                      <div key={id} className="item">
                        <h3 className="single-previous-speaker">
                          {SpeakerName}
                        </h3>
                      </div>
                    ),
                  )}
                </Slider>
              </div>
            </div> */}
          </div>
        </div>

        <section className="typer-section">
          <div className="small-container">
            <div className="row">
              <div className="col col-6">
                <div className="typer-section-content">
                  <h2 className="gradient-text">
                    <Typist
                      typingSpeed={typeSpeed}
                      deletingSpeed={50}
                      loop
                      sentences={[
                        'Game-Changing Technologies.',
                        'Unfiltered Expert Conversations.',
                        'Endless Networking Opportunities.',
                        'The Latest FinTech Products.',
                      ]}
                    />
                  </h2>

                  <h3>That's fintech in 2021!</h3>

                  <p>
                    Join us at <span>FTX 2021</span>, where we celebrate Fintech
                    innovation, milestones, and success stories and unravel what
                    the future has in store. 🙌
                  </p>

                  <Button
                    className="disabled"
                    onClick={withEventTracking(
                      'TYPER_SECTION',
                      bookingModalOpenToggle,
                    )}
                    primary>
                    Register Now
                  </Button>
                </div>
              </div>

              <div className="col col-6">
                <div className="typer-video">
                  <ImageWebp
                    srcWebp="https://ftx-rp.netlify.app/img/video-thumb.webp"
                    src="https://ftx-rp.netlify.app/img/video-thumb.png"
                    loading="lazy"
                  />

                  <button
                    type="button"
                    onClick={videoModalClick(1)}
                    className="video-play">
                    <img
                      src="https://ftx-rp.netlify.app/img/video-play.svg"
                      loading="lazy"
                      alt="play"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-main">
          <div className="small-container">
            <div className="row row-no-margin">
              <div className="col-3">
                <div className="single-stat">
                  <div>
                    <h3>10000+</h3>
                    <p>Attendees</p>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="single-stat">
                  <div>
                    <h3>100+</h3>
                    <p>Speakers</p>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="single-stat">
                  <div>
                    <h3>5000+</h3>
                    <p>Businesses</p>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="single-stat">
                  <div>
                    <h3>50+</h3>
                    <p>Sessions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="agenda-main"
          data-spy-title="Agenda"
          data-spy-id="agenda">
          <div className="small-container">
            <div className="agenda-text-block">
              <h2 className="big-heading center">
                {/* <LogoAnim />  */}
                <ImageWebp
                  srcWebp="https://ftx-rp.netlify.app/img/ftx21.webp"
                  src="https://ftx-rp.netlify.app/img/ftx21.png"
                  loading="lazy"
                  className="logo"
                />
                Agenda
              </h2>

              <div className="flex align-normal">
                <div className="col col-6">
                  <div className="agenda-box">
                    <h3>
                      Day 1 - <span className="gradient-text">9th Dec</span>
                    </h3>

                    <div className="agenda-wrapper first-agenda-wrapper">
                      {[
                        {
                          id: 0,
                          time: '10:00 am - 10:40 am',
                          description: 'Keynote by Razorpay',
                        },
                        {
                          id: 1,
                          time: '10:45 am - 11:25 am',
                          description: 'State of Union for Fintech Keynote',
                        },
                        {
                          id: 2,
                          time: '11:30 am - 12:30 pm',
                          description: 'Future of Fintech',
                        },
                        {
                          id: 3,
                          time: '12:30 pm - 01:30 pm',
                          description:
                            'Lunch Break: Watch Run For Cover perform live!',
                        },
                        {
                          id: 4,
                          time: '01:30 pm - 02:30 pm',
                          description: (
                            <>Neobanking: What's the real problem?</>
                          ),
                        },
                        {
                          id: 5,
                          time: '02:30 pm - 03:30 pm',
                          description: 'Embedded Finance: The next big thing',
                        },
                        {
                          id: 6,
                          time: '03:30 pm - 04:30 pm',
                          description: 'Keeping up with Regulations',
                        },

                        {
                          id: 7,
                          time: '04:30 pm - 05:15 pm',
                          description: 'Building technology platform for scale',
                        },
                        {
                          id: 8,
                          time: '05:15 pm - 06:30 pm',
                          description:
                            'Taking things to the next level | A fireside',
                        },
                      ].map(({ id, time, description }) => (
                        <div key={id} className="single-agenda">
                          <p className="gradient-text">{time}</p>
                          <h4>{description}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col col-6">
                  <div className="agenda-box">
                    <h3>
                      Day 2 - <span className="gradient-text">10th Dec</span>
                    </h3>

                    <div className="agenda-wrapper">
                      {[
                        {
                          id: 0,
                          time: '10:30 am - 11:30 am',
                          description: 'Designing for Bharat',
                        },
                        {
                          id: 1,
                          time: '11:30 am - 12:30 pm',
                          description: 'All about capital markets',
                        },
                        {
                          id: 2,
                          time: '12:30 pm - 1:00 pm',
                          description: 'Keynote Address by Amitabh Kant',
                        },
                        {
                          id: 4,
                          time: '1 pm - 2 pm',
                          description:
                            'Lunch Break: Watch Dark Light perform live!',
                        },
                        {
                          id: 5,
                          time: '2 pm - 3 pm',
                          description: 'Whats next in Payments',
                        },

                        {
                          id: 6,
                          time: '3 pm - 4 pm',
                          description:
                            'Enabling Digital India; The new age of disruptors',
                        },
                        {
                          id: 7,
                          time: '4 pm - 5 pm',
                          description: 'Innovations in the Insurance industry',
                        },

                        {
                          id: 8,
                          time: '5 pm - 6 pm',
                          description: 'Blockchain & CryptoCurrency Boom',
                        },
                        {
                          id: 9,
                          time: '6:00 pm - 6:30 pm',
                          description: 'Surprise Set',
                        },
                      ].map(({ id, time, description }) => (
                        <div key={id} className="single-agenda">
                          <p className="gradient-text">{time}</p>
                          <h4>{description}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="agenda-buttons row no-margin">
                {/* <Button href="#!" primary>
                  Download Agenda
                </Button> */}
                <Button
                  className="disabled"
                  onClick={bookingModalOpenToggle}
                  primary>
                  REGISTER NOW
                </Button>
              </div>
            </div>
          </div>

          <div
            className="tab-block"
            data-spy-title="What's More"
            data-spy-id="whats-more">
            <div className="small-container">
              <h2 className="big-heading">And there’s more</h2>
              <p className="subhead">
                We're always working on making FTX bigger and better. Check out
                the exciting events and activities we have lined up!
              </p>
              <div className="tab-controls">
                <button
                  onClick={withEventTracking('MASTERCLASS', tabOpenClick(0))}
                  className={`${tabOpen === 0 ? 'active' : ''}`}
                  type="button">
                  MASTERCLASSES
                </button>
                <button
                  onClick={withEventTracking('HACKATHON', tabOpenClick(1))}
                  type="button"
                  className={`${tabOpen === 1 ? 'active' : ''}`}>
                  HACKATHON
                </button>
              </div>

              <div className="tab-content">
                <div className={`single-tab ${tabOpen === 0 ? 'active' : ''}`}>
                  <div className="row">
                    <div className="col col-6">
                      <div className="tab-img">
                        <ImageWebp
                          srcWebp="https://ftx-rp.netlify.app/img/masterclass.webp"
                          src="https://ftx-rp.netlify.app/img/masterclass.jpg"
                          loading="lazy"
                          alt="masterclass"
                        />
                      </div>
                    </div>
                    <div className="col col-5 offset-1">
                      <div className="tab-details">
                        <p>
                          Learn how to build FinTech products that solve for
                          real-world pain points from the experts who have it
                          aced. ✨
                        </p>
                        <Button
                          className="disabled"
                          onClick={bookingModalOpenToggle}
                          primary>
                          REGISTER NOW
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`single-tab ${tabOpen === 1 ? 'active' : ''}`}>
                  <div className="row">
                    <div className="col col-6">
                      <div className="tab-img">
                        <ImageWebp
                          srcWebp="https://ftx-rp.netlify.app/img/hackathon.webp"
                          src="https://ftx-rp.netlify.app/img/hackathon.jpg"
                          loading="lazy"
                          alt="hackathon"
                        />
                      </div>
                    </div>
                    <div className="col col-5 offset-1">
                      <div className="tab-details">
                        <p>
                          A chance to put your technical and creative skills to
                          use to build what the future of FinTech would look
                          like, and win exciting rewards! ✨
                        </p>
                        <Button
                          target="_blank"
                          href="https://www.ftx-hackathon-2021.newtonschool.co/"
                          primary>
                          REGISTER NOW
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="pricing-main"
          data-spy-title="Ticketing"
          data-spy-id="ticketing">
          <div className="small-container">
            <div className="pricing-header">
              <h2 className="gradient-text">
                You don’t want to miss this <span>opportunity!</span>
              </h2>

              {/* <p className="subhead">
                Choose your ticket and book now before slots run out! All
                proceeds go directly to&nbsp;
                <span style={{ fontWeight: 800, color: '#fff' }}>
                  Child Rights and You Foundation
                </span>
              </p>
              <img
                src="https://ftx-rp.netlify.app/img/cry-foundation.png"
                alt="cry-foundation"
              /> */}

              {/* <p> */}
              {/*  Early Bird Free Registrations until{' '} */}
              {/*  <span style={{ fontWeight: 800, color: '#fff' }}> */}
              {/*    17th November */}
              {/*  </span>{' '} */}
              {/*  - book your free pass now! */}
              {/* </p> */}
              {renderSubtext()}
            </div>
          </div>

          {renderPricingBlock()}
        </section>

        <section
          className="ftx-for-main"
          data-spy-title="Who Should Attend"
          data-spy-id="who-should-attend">
          <div className="container">
            <div className="ftx-for-block">
              <div className="center-bubble-block">
                <h2>
                  Who should attend
                  {/* <LogoAnim /> */}
                  <ImageWebp
                    srcWebp="https://ftx-rp.netlify.app/img/ftx21.webp"
                    src="https://ftx-rp.netlify.app/img/ftx21.png"
                    loading="lazy"
                    alt="masterclass"
                    className="logo"
                  />
                </h2>
              </div>
              <div className="ftx-for-wrapper">
                {[
                  {
                    id: 0,
                    title: 'Product and tech enthusiasts',
                    description:
                      'Meet your peers and partners under the same virtual roof ',
                    image: '/img/bubble.mp4',
                  },
                  {
                    id: 1,
                    title: 'Trailblazing SMEs',
                    description:
                      ' Uncover insights on taking your business to its next phase of growth. ',
                    image: '/img/bubble-1.mp4',
                  },
                  {
                    id: 2,
                    title: 'Fast growing startups',
                    description:
                      'Hear from veteran entrepreneurs on how to build a business that outlasts you',
                    image: '/img/bubble.mp4',
                  },
                  {
                    id: 3,
                    title: 'Government dignitaries',
                    description:
                      'Learn how to build robust public digital platforms',
                    image: '/img/bubble.mp4',
                  },
                  {
                    id: 4,
                    title: 'Game-changing enterprises',
                    description:
                      'Learn how you can supercharge digital transformation for your business ',
                    image: '/img/bubble-1.mp4',
                  },
                  {
                    id: 5,
                    title: 'Fintech veterans',
                    description:
                      ' Stay up to speed with what’s been brewing in the domain',
                    image: '/img/bubble.mp4',
                  },
                  {
                    id: 6,
                    title: 'New-age bankers',
                    description:
                      ' Explore the latest in neo-banking and customer experience ',
                    image: '/img/bubble.mp4',
                  },
                ].map(({ id, title, description, image }) => (
                  <div
                    key={id}
                    className={`single-bubble-block bubble-block-${id}`}>
                    <video src={image} loop autoPlay muted playsInline />

                    <div className="bubble-block-content">
                      <h3>{title}</h3>
                      <p>{description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section
          className="past-ftx-main"
          data-spy-title="Previous Editions"
          data-spy-id="previous-editions">
          <div className="small-container">
            <h2 className="big-heading">
              SPEARHEADING THE FINTECH REVOLUTION, YEAR IN YEAR OUT!
            </h2>

            <p className="subhead" style={{ maxWidth: 710 }}>
              FTX has challenged the status quo of global FinTech conferences.
              Check out our past editions!
            </p>
            <div className="past-ftx-wrapper">
              <div className="row">
                <div className="col col-6">
                  <div className="single-past-ftx">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/ftx-2020.webp"
                      src="https://ftx-rp.netlify.app/img/ftx-2020.jpg"
                      loading="lazy"
                    />

                    <button
                      onClick={videoModalClick(2)}
                      className="past-ftx-button"
                      type="button">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          fill="none"
                          viewBox="0 0 40 40">
                          <circle
                            cx="20"
                            cy="20"
                            r="19.5"
                            fill="#000"
                            stroke="url(#paint0_linear_1435_869)"
                          />
                          <path
                            fill="url(#paint1_linear_1435_869)"
                            d="m26 20-9 5.196V14.804L26 20Z"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1435_869"
                              x1="20"
                              x2="20"
                              y1="0"
                              y2="40"
                              gradientUnits="userSpaceOnUse">
                              <stop stopColor="#CE50EE" />
                              <stop offset="1" stopColor="#8C35F1" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1435_869"
                              x1="26"
                              x2="25.578"
                              y1="13.337"
                              y2="32.359"
                              gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FC62ED" />
                              <stop offset="1" stopColor="#1907F6" />
                            </linearGradient>
                          </defs>
                        </svg>
                        2020
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col col-6">
                  <div className="single-past-ftx">
                    <ImageWebp
                      srcWebp="https://ftx-rp.netlify.app/img/ftx-2019.webp"
                      src="https://ftx-rp.netlify.app/img/ftx-2019.jpg"
                      alt="ftx 2019"
                      loading="lazy"
                    />

                    <button
                      onClick={videoModalClick(3)}
                      className="past-ftx-button"
                      type="button">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          fill="none"
                          viewBox="0 0 40 40">
                          <circle
                            cx="20"
                            cy="20"
                            r="19.5"
                            fill="#000"
                            stroke="url(#paint0_linear_1435_869)"
                          />
                          <path
                            fill="url(#paint1_linear_1435_869)"
                            d="m26 20-9 5.196V14.804L26 20Z"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1435_869"
                              x1="20"
                              x2="20"
                              y1="0"
                              y2="40"
                              gradientUnits="userSpaceOnUse">
                              <stop stopColor="#CE50EE" />
                              <stop offset="1" stopColor="#8C35F1" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1435_869"
                              x1="26"
                              x2="25.578"
                              y1="13.337"
                              y2="32.359"
                              gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FC62ED" />
                              <stop offset="1" stopColor="#1907F6" />
                            </linearGradient>
                          </defs>
                        </svg>
                        2019
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <p className="subhead">Previous Year Speakers</p>
            <div className="previous-speakers">
              <Slider
                arrows={false}
                dots={false}
                infinite
                slidesToShow={3}
                slidesToScroll={0.2}
                autoplay
                autoplaySpeed={0}
                speed={3000}
                cssEase="linear"
                centerMode
                variableWidth
                responsive={[
                  {
                    breakpoint: 990,
                    settings: {
                      slidesToShow: 2,
                    },
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                    },
                  },
                ]}>
                <div className="item">
                  <h3 className="single-previous-speaker">KUNAL SHAH</h3>
                </div>
                <div className="item">
                  <h3 className="single-previous-speaker">VIKALP SAHNI</h3>
                </div>
                <div className="item">
                  <h3 className="single-previous-speaker">SHASHANK KUMAR</h3>
                </div>
                <div className="item">
                  <h3 className="single-previous-speaker">LIZZIE CHAPMAN</h3>
                </div>
              </Slider>
            </div> */}
          </div>
        </section>

        <section className="faq-main" data-spy-title="FAQs" data-spy-id="faqs">
          <div className="small-container">
            <h2 className="big-heading" style={{ maxWidth: 970 }}>
              All you need to know about
              {/* <LogoAnim /> */}
              <ImageWebp
                srcWebp="https://ftx-rp.netlify.app/img/ftx21.webp"
                src="https://ftx-rp.netlify.app/img/ftx21.png"
                alt=""
                loading="lazy"
                className="logo"
              />
            </h2>

            <p className="subhead" style={{ maxWidth: 720 }}>
              Mark your calendars for the{' '}
              <span style={{ color: '#fff', fontWeight: 600 }}>
                9th and 10th of December, 2021
              </span>{' '}
              and get ready to be a part of the most awaited fintech event of
              the year! Got any questions? We’ve got you covered.
            </p>

            <div className="faq-block">
              <div className="row row-no-margin align-normal">
                <div className="col-6">
                  <div className="faq-questions-main">
                    {Faq.map(({ id, answer, question }) => (
                      <div key={id} className="single-faq-block">
                        <div
                          className={`faq-question ${
                            faq === id ? 'active' : ''
                          }`}>
                          <button type="button" onClick={faqClick(id)}>
                            <svg
                              className="faq-question-circle"
                              width="14"
                              height="14"
                              fill="none"
                              viewBox="0 0 14 14">
                              <rect
                                width="11.963"
                                height="11.963"
                                x="-1.267"
                                y="7"
                                fill="#000"
                                stroke="url(#paint0_linear_841:22224)"
                                strokeWidth="1.037"
                                rx="5.982"
                                transform="rotate(-45 -1.267 7)"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_841:22224"
                                  x1="4.5"
                                  x2="-3.278"
                                  y1="7"
                                  y2="33.734"
                                  gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#B76639" />
                                  <stop offset="1" stopColor="#6E26E6" />
                                </linearGradient>
                              </defs>
                            </svg>
                            {question}
                            <svg
                              className="faq-arrow"
                              width="18"
                              height="16"
                              fill="none"
                              viewBox="0 0 18 16">
                              <path
                                strokeWidth="2"
                                d="M8.727.727 15.999 8l-7.272 7.273M16 8.272H0"
                              />
                            </svg>
                          </button>
                        </div>
                        <div className="visible-mobile">
                          <div
                            className={`faq-answer ${
                              faq === id ? 'active' : ''
                            }`}>
                            {answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-6 hidden-mobile">
                  <div className="faq-answer-block">
                    {Faq.map(({ id, question, answer }) => (
                      <div
                        key={id}
                        className={`answer-wrapper ${
                          faq === id ? 'active' : ''
                        }`}>
                        <h3>{question}</h3>
                        {answer}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Scrollspy>
      <Footer />

      <div className={`video-modal ${videoModal ? 'show-modal' : ''}`}>
        <div className="video-modal-wrapper">
          <button
            type="button"
            onClick={videoModalClick(false)}
            className="close-video-modal">
            <span className="close-popup">&nbsp;</span>
          </button>

          <iframe
            src={videoLnks[videoModal]}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen></iframe>
        </div>
      </div>

      <BookingModal
        bookingModalOpen={bookingModalOpen}
        bookingModalOpenToggle={bookingModalOpenToggle}
        location={location}
        offer99={offer99}
        mentorship={mentorship}
      />

      <EarlyAccessModal
        openTicketModal={openTicketModal}
        setOpenTicketModal={setOpenTicketModal}
        location={location}
      />
    </Layout>
  );
};

Landing.defaultProps = {
  lottie: null,
  offer99: false,
  mentorship: false,
};

Landing.propTypes = {
  lottie: PropTypes.shape({}),
  location: PropTypes.object.isRequired,
  offer99: PropTypes.bool,
  mentorship: PropTypes.bool,
};

export default makeAsyncScriptLoader(
  'https://checkout.razorpay.com/v1/checkout.js',
)(Landing);
